import styled, { keyframes } from 'styled-components';

const animateDown = keyframes`
  0% {
    transform: translateY(-100%);
    opacity: 0;
  }
  100% {
    transform: translateY(0);
    opacity: 1;
  }
`;
export const BannerContainer = styled.div`
  position: fixed;
  z-index: 10;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  animation: ${animateDown} 1s forwards;
`;
